var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",style:(_vm.styleObject),on:{"click":function($event){return _vm.$emit('click')}}},[_c('inline-svg',{style:(_vm.svgStyles),attrs:{"src":_vm.processedSrc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }